import { boolean, number, object } from 'yup';

export interface ExportTournamentResultsForm {
  limit: number | '';
  onlyWinners: boolean;
}

export const initialValues: ExportTournamentResultsForm = {
  limit: '',
  onlyWinners: true,
};

export const validationSchema = object().shape({
  limit: number()
    .transform((v, orig) => (orig === '' ? undefined : v))
    .integer('Limit must be an integer')
    .positive('Limit must be greater than 0'),
  onlyWinners: boolean().required(),
});
